import React, { Component } from "react";
import { FormattedMessage } from "react-intl";

const NotResponsive = () => {
  return (
    <div className="notResponsiveAtAll">
      <div
        className="notResponsiveAtAll-wrapper"
        style={{ textAlign: "center" }}
      >
        <div className="notResponsiveAtAll--logo">
          <img alt="" src="/images/icons/monitoringText.png" />
        </div>
        <h1 className="notResponsiveAtAll--title">
          <FormattedMessage id="notResponsive" />
        </h1>
      </div>
    </div>
  );
};

export default NotResponsive;
